<template>
  <div class="row">
    <div class="col-md-12">
      <p class="clearfix"></p>
      <loyalty-store-campaign-form :route="route"></loyalty-store-campaign-form>
    </div>
  </div>
</template>

<script>
import LoyaltyStoreCampaignForm from './LoyaltyStoreCampaignForm.vue'

export default {
  components: { LoyaltyStoreCampaignForm },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/LoyaltyStore/LoyaltyStoreCampaignEdit.vue